<script lang="ts" setup>
import type { CrossSectionType } from '@/stores/type/crossSection.type'
import type { PropType } from 'vue'
import BaseCrossSectionDataTable from '@/components/calculation-result/BaseCrossSectionDataTable.vue'

const props = defineProps({
  item: { type: Object as PropType<CrossSectionType>, required: true }
})

const tableRowFields: (keyof CrossSectionType | null)[] = [
  'calculation_method',
  'calculation_type',
  'max_velocity_at_bed_main_engine',
  'max_velocity_at_bed_transverse_thruster',
  'normative_flow_velocity_at_bed',
  'vessel_name',
  'main_engine_initial_velocity',
  'transverse_thruster_initial_velocity'
]
</script>

<template>
  <BaseCrossSectionDataTable
    :item="item"
    table-header="Flow data"
    :choice-fields="['calculation_method', 'calculation_type']"
    :table-row-fields="tableRowFields"
  />
</template>
